/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProtectionStatus {
    getFixupPrototypeFunction() { return ProtectionStatus.fixupPrototype; }

    static newInstance(model: Partial<ProtectionStatus>): ProtectionStatus {
        let obj = Object.assign(new ProtectionStatus(), model);
        ProtectionStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProtectionStatus>): ProtectionStatus {
        if (!model) return null;
        return ProtectionStatus.newInstance(<ProtectionStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProtectionStatus) {
        if (!obj) return;

        models.ProtectionStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProtectionStatus): boolean {
        Object.setPrototypeOf(obj, ProtectionStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Indicates if protection status is supported
     */
    enabled: boolean;

    /**
     * Indicates if the resource is protected
     */
    status: boolean;

}
